import dayjs from 'dayjs'
/**
 * 返回毫秒数
 * @param milliseconds - 毫秒数
 * @param HHmmss - 时分秒的格式：HH:mm:ss(即23:59:59)
 * @return milliseconds*/
export function getSomeTimeMilliseconds(milliseconds, HHmmss) {
    let date = dayjs(milliseconds).format("YYYY-MM-DD").toString()
    let dateStr = HHmmss ? `${date} ${HHmmss}` : date
    let formatStr = HHmmss ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
    // return dayjs(dateStr, formatStr).format('x')
    console.log("返回毫秒数",dateStr,formatStr,dayjs(dateStr,formatStr).valueOf())
    return dayjs(dateStr,formatStr).valueOf()
}
